/*
 * SPDX-FileCopyrightText: © 2024 Schneider Electric
 *
 * SPDX-License-Identifier: Apache-2.0
 */

@import url('../shared.css');

:host {
  display: block;
  width: 100%;
}

.qds-track,
.qds-bar {
  overflow: hidden;
}

.qds-track {
  background-color: var(--qds-theme-control-slider-track-inactive);
  border-radius: var(--qds-signature-line-progress-cap-radius);
}

.qds-bar {
  background-color: var(--qds-theme-signature-line-progress-determinate);
  border-radius: var(--qds-signature-line-progress-cap-radius);
  transition: width 0.6s cubic-bezier(0.83, 0, 0.17, 1);
}

@media (prefers-reduced-motion) {
  .qds-bar {
    transition: none;
  }
}

.qds-indeterminate {
  animation: indeterminate 2s linear infinite;
  background-color: transparent;
  background-image: var(--qds-theme-signature-line-progress-indeterminate);
}

@keyframes indeterminate {
  from {
    transform: translateX(-100%);
  }

  to {
    transform: translateX(200%);
  }
}

[data-size='small'] {
  height: var(--qds-signature-line-progress-small-height);
}

[data-size='standard'] {
  height: var(--qds-signature-line-progress-standard-height);
}

[data-size='large'] {
  height: var(--qds-signature-line-progress-large-height);
}
